import React from 'react';

interface IRadio {
  label: string;
  value: string;
  name: string;
  checked: boolean;
  id: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export default function Radio({
  label,
  value,
  name,
  checked,
  id,
  onChange,
}: IRadio) {
  return (
    <div>
      <input
        id={id}
        value={value}
        name={name}
        type={'radio'}
        checked={checked}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange ? onChange(e) : null
        }
        className={'hidden peer'}
      />
      <label
        htmlFor={id}
        className={
          'flex items-center gap-3 text-primary cursor-pointer before:block before:w-[18px] before:h-[18px] before:flex-shrink-0 before:transition before:duration-300 before:rounded-full before:border before:border-borderColor peer-checked:before:border-[5px] peer-checked:before:border-blue'
        }
      >
        {label}
      </label>
    </div>
  );
}
